// extracted by mini-css-extract-plugin
module.exports = {"CommentList":"CommentList_CommentList__vsClH"};